import { Plus, Trash2 } from "lucide-react";
import Button from "../../components/Button";
import FormField from "../../components/FormField";
import IconButton from "../../components/IconButton";
import TextInput from "../../components/TextInput";

const valueOrDash = (value) => value === undefined || value === null || value === "" ? "Not recorded" : value;
const errorFor = (errors, path) => errors?.[path]?.[0] || "";

const ReadOnlyGrid = ({ items }) => (
  <dl className="wsm-record-grid">
    {items.map(({ label, value }) => <div key={label}><dt>{label}</dt><dd>{valueOrDash(value)}</dd></div>)}
  </dl>
);

const LiveLineTester = (props) => {
  const formData = props.formData || {};
  const locationData = props.locationData || {};
  const authorisedPeople = Array.isArray(formData.authorised_people) && formData.authorised_people.length > 0 ? formData.authorised_people : [{}];

  return (
    <div className="wsm-live-line-tester">
      <section className="wsm-pack-form-section">
        <div className="wsm-pack-form-section__heading">
          <div><h3>Authorised people</h3><p>Add the people authorised to complete the live line testing record.</p></div>
          {authorisedPeople.length < 6 && <Button icon={Plus} onClick={() => props.handleAddFormRow("forms.live_line_tester.authorised_people", {})} size="compact" type="button" variant="outline">Add person</Button>}
        </div>
        <div className="wsm-pack-form-section__entries">
          {authorisedPeople.map((person, index) => (
            <article className="wsm-pack-form-section__entry" key={`authorised-person-${index}`}>
              <div className="wsm-pack-form-section__entry-heading">
                <h4>Authorised person {index + 1}</h4>
                <IconButton aria-label={`Remove authorised person ${index + 1}`} disabled={index === 0} icon={Trash2} onClick={() => props.handleRemoveFormRow("forms.live_line_tester.authorised_people", index, true, "authorised person")} size="compact" variant="destructive" />
              </div>
              <div className="wsm-live-line-tester__person-grid">
                <FormField error={errorFor(props.errors, `data.forms.live_line_tester.authorised_people.${index}.authorised_person`)} id={`authorised-person-${index}`} label="Authorised person">
                  {(fieldProps) => <TextInput {...fieldProps} onChange={(event) => props.handleInputChange(`forms.live_line_tester.authorised_people.${index}.authorised_person`, event.target.value)} value={person.authorised_person || ""} />}
                </FormField>
                <div className="wsm-readonly-field"><span>Date</span><strong>{valueOrDash(person.date)}</strong></div>
              </div>
            </article>
          ))}
        </div>
        <p className="wsm-live-line-tester__limit" aria-live="polite">{authorisedPeople.length} of 6 people added</p>
      </section>

      <section className="wsm-record-section">
        <div className="wsm-record-section__heading"><h4>Pack references</h4><p>Inherited from the location step.</p></div>
        <ReadOnlyGrid items={[{ label: "WON week number", value: locationData.week_no }, { label: "WON item number", value: locationData.won_item_no }]} />
      </section>

      <section className="wsm-record-section">
        <div className="wsm-record-section__heading"><h4>Tester and permit details</h4><p>Completed when the live line testing record is used.</p></div>
        <ReadOnlyGrid items={[
          { label: "Permit number", value: formData.permit_no },
          { label: "Name", value: formData.ll_name },
          { label: "LTT number", value: formData.llt_number },
          { label: "PU number", value: formData.pu_number },
          { label: "Calibration date", value: formData.calibration_date },
          { label: "Checked by", value: formData.ll_checked_by },
        ]} />
      </section>
    </div>
  );
};

export default LiveLineTester;